export function useQuery() {
    const params = new URLSearchParams(
      window ? window.location.search : {}
    );

    return new Proxy(params, {
        get(target, prop: any) {
            return target.get(prop)
        },
    });
}
